import { roundMoney, toNumber } from './obracunFields';

export function getPersonEarningsForMonth(earningsData, personId, selectedYear, selectedMonth) {
  return earningsData.filter(
    (e) =>
      e.userId === personId &&
      e.year === selectedYear &&
      e.month === selectedMonth
  );
}

/** Zbroji sve zarade za tjedan (Glovo 1-5, Wolt w1/w2), uklj. legacy period zapise */
export function sumEarningsByWeek(personEarnings) {
  const weekTotals = {
    tjedan1: 0,
    tjedan2: 0,
    tjedan3: 0,
    tjedan4: 0,
    tjedan5: 0,
    w1: 0,
    w2: 0,
  };

  personEarnings.forEach((earning) => {
    const amount = toNumber(earning.amount);
    const isWolt =
      earning.platform === 'wolt' || earning.week === 'w1' || earning.week === 'w2';

    if (isWolt) {
      if (earning.week === 'w1') weekTotals.w1 += amount;
      else if (earning.week === 'w2') weekTotals.w2 += amount;
    } else {
      const weekKey = `tjedan${earning.week}`;
      if (weekTotals[weekKey] !== undefined) weekTotals[weekKey] += amount;
    }
  });

  const zaradaTotal = roundMoney(
    personEarnings.reduce((sum, e) => sum + toNumber(e.amount), 0)
  );

  Object.keys(weekTotals).forEach((k) => {
    weekTotals[k] = roundMoney(weekTotals[k]);
  });

  return { weekTotals, zaradaTotal };
}
